import { createAsyncThunk, isRejectedWithValue } from "@reduxjs/toolkit";
import { fetchShiftGroupApi, updateShiftGroupApi, createShiftGroupApi, deleteShiftGroupApi, checkDeleteShiftGroupApi, checkDeleteShiftApi,getShiftGroupByIdApi } from "./ShiftGroupApi";
import { shiftListApi, createShiftApi, getShiftByIdApi, updateShiftApi, deleteShiftApi } from "./ShiftGroupApi";
import { showApiErrorToast, showApiSuccessToast } from "../../utils/toastErrorHandler";
import { toast } from "react-toastify";

const handleError = (err, rejectWithValue) => {
  if (err.response?.status === 401) {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
  }

  const data = err.response?.data;

  let errorMessage =
    data?.errors?.[0]?.msg ||
    data?.message ||
    data?.error ||
    err.message ||
    "Something went wrong";

  showApiErrorToast(errorMessage);

  return rejectWithValue(errorMessage);
};

export const shiftGroupListsApis = createAsyncThunk(
    "shiftGroup/fetchList",
    async ( payload, { rejectWithValue}) => {
        try{
            return await fetchShiftGroupApi(payload )
        } 
        catch (err) {
            return handleError(err, rejectWithValue);
        }
    }
);

export const getShiftGroupById = createAsyncThunk(
  "shiftGroup/getShiftGroupById",
  async (payload, { rejectWithValue}) => {
    try{
      return await getShiftGroupByIdApi(payload)
    }
    catch(err) {
      return handleError(err, rejectWithValue);
    }
  }
)
export const updateShiftGroup = createAsyncThunk(
    "shiftGroup/update",
    async(payload, { rejectWithValue}) => {
        try{
            const response= await updateShiftGroupApi(payload);
            showApiSuccessToast(
                response.data.message
            );
            return response;
            // return await updateShiftGroupApi(payload)
        }
        catch(err){
            return handleError(err, rejectWithValue)
        }
    }
)

export const createShiftGroup = createAsyncThunk(
    "shiftGroup/create",
    async(payload, { rejectWithValue}) => {
        try{

            const response = await createShiftGroupApi(payload);
            showApiSuccessToast(
                response.data.message
            );

            return response;
            // return await createShiftGroupApi(payload)
        }
        catch(err){
            return handleError(err, rejectWithValue)
        }
    }
)

export const deleteShiftGroup = createAsyncThunk(
    "shiftGroup/delete",
    async(payload, {rejectWithValue}) => {
        try{
            const response = await deleteShiftGroupApi(payload);
            showApiSuccessToast(
                response.data.message
            );
            return response
            // return await deleteShiftGroupApi(payload)
        }
        catch(err){
            return handleError(err, rejectWithValue)
        }
    })

    export const checkDeleteShift = createAsyncThunk(
        "shiftGroup/delete_shift",
        async(payload, {rejectWithValue}) => {
            try{
               return await checkDeleteShiftApi(payload)
            }
            catch(err) {
                return handleError(err, rejectWithValue)
            }
        }
    )

   
    export const shiftList = createAsyncThunk(
    "shiftGroup/shiftlist",
    async(payload, { rejectWithValue}) => {
        try{

            const response = await shiftListApi(payload);
            return response;
        }
        catch(err){
            return handleError(err, rejectWithValue)
        }
    }
)
  export const createShift = createAsyncThunk(
  "shiftGroup/create_list",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await createShiftApi(payload);

      showApiSuccessToast(response.data.message);

      return response;
    } catch (err) {
      return handleError(err, rejectWithValue);
    }
  }
);

export const getShiftById = createAsyncThunk(
  "shiftGroup/getShiftById",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getShiftByIdApi(payload);
      return response;
    } catch (err) {
      return handleError(err, rejectWithValue);
    }
  }
);

export const updateShift = createAsyncThunk(
  "shiftGroup/updateShift",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await updateShiftApi(payload);
      showApiSuccessToast(response.data.message);
      return response;
    } catch (err) {
      return handleError(err, rejectWithValue);
    }
  }
);

export const checkDeleteShiftGroup = createAsyncThunk(
  "shiftGroup/delete_list",
  async (payload, { rejectWithValue }) => {
    try {
      return await checkDeleteShiftGroupApi(payload);
    } catch (err) {
      return handleError(err, rejectWithValue);
    }
  }
);

export const deleteShift = createAsyncThunk(
  "shiftGroup/delete_list",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await deleteShiftApi(payload);

      showApiSuccessToast(response.data.message);

      return response;
    } catch (err) {
      return handleError(err, rejectWithValue);
    }
  }
);

// export const deleteShift = createAsyncThunk(
//     "shift/delete",
//     async (payload, { rejectWithValue }) => {
//         try {
//             const response = await deleteShiftApi(payload);

//             showApiSuccessToast(response.data.message);

//             return response;
//         } catch (err) {
//             return handleError(err, rejectWithValue);
//         }
//     }
// );
